import { getPropertySectionNoTitle } from 'shared/utils/client'
import { staticTerminology } from 'shared/constants/terminology'
import { getActiveClient, getActiveClientId } from '../clients/selectors'
import terminologyApi from './terminology.service'
import { RootState } from '../store'

export const getTerminology = (state: RootState) => {
  const id = getActiveClientId(state) || ''
  const terminology = terminologyApi.endpoints.getTerminology.select(id)(state)
  return { ...terminology, data: terminology.data || staticTerminology }
}

export const propertySectionNoTitle = (state: RootState) => {
  const client = getActiveClient(state)
  const terminology = getTerminology(state)

  return (short: boolean = true) =>
    getPropertySectionNoTitle(
      terminology.data.Enhet,
      client?.clientType.companyTypeCode,
      short
    )
}
